export const normalizeVin = (vin: string | null | undefined): string | undefined => {
    if (typeof vin !== 'string') {
        return undefined;
    }

    const normalizedVin = vin.trim().toUpperCase();
    return normalizedVin || undefined;
};
